import script from "./CustomZoomer.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomZoomer.vue?vue&type=script&setup=true&lang=ts"

import "./CustomZoomer.vue?vue&type=style&index=0&id=4ed1dfd7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ed1dfd7"]])

export default __exports__